export default {

	"online_payment": {
		"en": "Online payment",
		"pl": "Płatność online",
		"ru": "Онлайн платеж",
		"ua": "Онлайн оплата"
	},

	"online_payment_text": {
		"en": "It's so simple! Pay conveniently from home and your payment confirmation will be automatically attached to your booked appointment.",
		"pl": "To takie proste! Zapłać wygodnie z domu, a potwierdzenie Twojej płatności zostanie automatycznie dołączone do zarezerwowanej przez Ciebie wizyty.",
		"ru": "Это так просто! Платите удобно из дома, и ваше подтверждение оплаты будет автоматически прикреплено к забронированной вами встрече.",
		"ua": "Це так просто! Зручно оплачуйте, не виходячи з дому, і підтвердження оплати буде автоматично додано до заброньованого прийому."
	},

	"step_services_heading": {
		"en": "Select the services you want to pay for.",
		"pl": "Wybierz usługi, za które chcesz uiścić opłatę.",
		"ru": "Выберите услуги, которые хотите оплатить.",
		"ua": "Виберіть послуги, за які хочете оплатити."
	}, 

	"step_services_error": {
		"en": "You must select the services you want to pay for.",
		"pl": "Musisz wybrać usługi za które chcesz uiścić opłatę.",
		"ru": "Вы должны выбрать услуги, которые хотите оплатить.",
		"ua": "Ви повинні вибрати послуги, за які ви хочете оплатити."
	},

	"step_methods_heading": {
		"en": "Choose a one-time payment method:",
		"pl": "Wybierz jednorazową formę płatności:",
		"ru": "Выберите способ единоразовой оплаты:",
		"ua": "Виберіть одноразовий спосіб оплати:"
	},

	"step_methods_error": {
		"en": "You must select a payment method to continue.",
		"pl": "Aby kontynuować musisz wybrać formę płatności.",
		"ru": "Чтобы продолжить, необходимо выбрать способ оплаты.",
		"ua": "Щоб продовжити, потрібно вибрати спосіб оплати."
	},

	"step_summary_heading": {
		"en": "Summary",
		"pl": "Podsumowanie",
		"ru": "Резюме",
		"ua": "Резюме"
	},

	"step_summary_error": {
		"en": "To make a payment, you must accept the content of the regulations and consent to the processing of personal data.",
		"pl": "Aby dokonać płatności musisz zaakceptować treść regulaminu oraz wyrazić zgodę na przetwarzanie danych osobowych.",
		"ru": "Для совершения платежа необходимо принять содержание регламента и дать согласие на обработку персональных данных.",
		"ua": "Щоб здійснити платіж, ви повинні прийняти зміст нормативних актів і дати згоду на обробку персональних даних."
	},

	"step_summary_safety_heading": {
		"en": "The security of the transaction is guaranteed by Autopay",
		"pl": "Bezpieczeństwo transakcji gwarantuje Autopay",
		"ru": "Безопасность сделки гарантирует Autopay",
		"ua": "Безпека транзакції гарантується Autopay"
	},

	"step_summary_safety_text": {
		"en": "Internet transfers are handled by Autopay S.A. with headquarters in Sopot, ul. Powstańców Warszawy 6, 81-718 Sopot, entered in the register of entrepreneurs kept by the District Court Gdańsk-Północ in Gdańsk, VIII Economic Department of the National Court Register under the KRS number 0000320590, NIP 585-13-51-185, Regon 191781561, with the share capital of PLN 2,000,000 (fully paid up), supervised by the Polish Financial Supervision Authority and entered in the register of national payment institutions under the number IP17/2013.Autopay S.A. ensures the highest level of security of the executed transactions.",
		"pl": "Przelewy internetowe są obsługiwane przez Autopay S.A. z siedzibą w Sopocie przy ul. Powstańców Warszawy 6, 81-718 Sopot, wpisaną do rejestru przedsiębiorców prowadzonego przez Sąd Rejonowy Gdańsk-Północ w Gdańsku, VIII Wydział Gospodarczy Krajowego Rejestru Sądowego pod numerem KRS 0000320590, NIP 585-13-51-185, Regon 191781561, o kapitale zakładowym w wysokości 2 000 000 PLN (w całości opłaconym), nadzorowaną przez Komisję Nadzoru Finansowego i wpisaną do rejestru krajowych instytucji płatniczych pod numerem IP17/2013.Autopay S.A. zapewnia najwyższy poziom bezpieczeństwa realizowanych transakcji.",
		"ru": "Интернет-переводы поддерживаются компанией Autopay S.A. с юридическим адресом в Сопоте по адресу ул. Powstańców Warszawy 6, 81-718 Sopot, внесенная в реестр предпринимателей, который ведет Окружной суд Гданьск-Пульнок в Гданьске, VIII Коммерческое отделение Национального судебного реестра под номером KRS 0000320590, NIP 585-13-51-185, Regon 191781561, с уставным капиталом 2 000 000 злотых (полностью оплаченным), под надзором Польской службы финансового надзора и внесенная в реестр национальных платежных учреждений под номером IP17/2013. Autopay S.A. обеспечивает высокий уровень безопасности выполняемых транзакций.",
		"ua": "Інтернет-перекази підтримує компанія Autopay S.A. з місцезнаходженням в Сопоті за адресою ul. Powstańców Warszawy 6, 81-718 Sopot, внесена до реєстру підприємців, який веде Окружний суд Гданськ-Пульноц в Гданську, VIII Комерційний відділ Національного судового реєстру під номером KRS 0000320590, NIP 585-13-51-185, Regon 191781561, зі статутним капіталом 2 000 000 злотих (повністю сплачений), під наглядом Польської фінансової інспекції та внесена до реєстру національних платіжних установ під номером IP17/2013. Autopay S.A. гарантує найвищий рівень безпеки проведених операцій."
	},


	"pay": {
		"en": "PAY",
		"pl": "ZAPŁAĆ",
		"ru": "ПЛАТИТЬ",
		"ua": "ПЛАТИТИ"
	},

	"do_not_pay_if": {
		"en": "DO NOT PAY IF",
		"pl": "NIE PŁAĆ JEŚLI",
		"ru": "НЕ ПЛАТИТЕ, ЕСЛИ",
		"ua": "НЕ ПЛАТИТЬ, ЯКЩО"
	},

	"pay_if": {
		"en": "PAY IF",
		"pl": "PŁAĆ JEŚLI",
		"ru": "ПЛАТИТЕ, ЕСЛИ",
		"ua": "ПЛАТИТЬ, ЯКЩО"
	},

	"fee_amount": {
		"en": "Fee amount",
		"pl": "Wysokość opłaty",
		"ru": "Величина платежа",
		"ua": "Розмір плати"
	},

	"transaction_amount:": {
		"en": "Transaction amount:",
		"pl": "Kwota transakcji:",
		"ru": "Сумма сделки:",
		"ua": "Сума транзакції:"
	},

	"commission_amount_for_blue_media:": {
		"en": "Commission amount for Blue Media:",
		"pl": "Kwota prowizji  dla Blue Media:",
		"ru": "Размер комиссии для Blue Media:",
		"ua": "Сума комісії для Blue Media:"
	},

	"amount_to_pay:": {
		"en": "Transaction amount:",
		"pl": "Kwota do zapłaty:",
		"ru": "Сумма к оплате:",
		"ua": "Сума до оплати:"
	},

	"skip_payment": {
		"en": "SKIP PAYMENT",
		"pl": "POMIŃ PŁATNOŚĆ",
		"ru": "ПРОПУСТИТЬ ОПЛАТУ",
		"ua": "ПРОПУСТИТИ ОПЛАТУ"
	},

	"skip_payment_heading": {
		"en": "Thank you for booking.",
		"pl": "Dziękujemy za dokonanie rezerwacji.",
		"ru": "Спасибо за бронирование.",
		"ua": "Дякуємо за бронювання."
	},

	"go_to_payment": {
		"en": "GO TO PAYMENT",
		"pl": "PRZEJDŹ DO PŁATNOŚCI",
		"ru": "ПЕРЕЙТИ К ОПЛАТЕ",
		"ua": "ПЕРЕЙТИ ДО ОПЛАТИ"
	},

	"payment_warning": {
		"en": "The matter you want to settle requires the payment of a stamp or administrative fee. Check the amount of the fee by clicking the button below, and then conveniently pay, use online payment.",
		"pl": "Sprawa, którą chcesz załatwić, wymaga wniesienia opłaty skarbowej lub administracyjnej. Zapoznaj się z wysokością opłaty klikając w poniższy przycisk, a następnie wygodnie zapłać, korzystać z płatności online.",
		"ru": "Вопрос, который вы хотите решить, требует оплаты печати или административного сбора. Уточняйте размер комиссии, нажав на кнопку ниже, а потом удобно оплачивайте, используя онлайн оплату.",
		"ua": "Справа, яку ви хочете вирішити, вимагає сплати гербового або адміністративного збору. Перевірте суму комісії, натиснувши кнопку нижче, а потім зручно оплатите, скориставшись онлайн-оплатою."
	},

	"payment_warning_button": {
		"en": "See the fees for the case",
		"pl": "Zapoznaj się z wysokością opłat za sprawę",
		"ru": "Посмотреть стоимость дела",
		"ua": "Подивіться гонорари за справу"
	}
}